const dateOnlyPattern = /^(\d{4})[-/](\d{2})[-/](\d{2})$/;

export const formatOmexDate = (date?: string) => {
  if (!date) {
    return "Sem data";
  }

  const dateOnlyMatch = date.match(dateOnlyPattern);

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return `${day}/${month}/${year}`;
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return parsedDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
